import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc28c474"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stock-search" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "fx-1 flex" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex-end" }

import { t } from '@/plugins/i18n'
import { ref, toRaw, watch, computed } from 'vue'
import { cloneDeep } from 'lodash'
import { clearForm, setDefaultForm } from '@/util/common'
import dblclick from '@/components/BatchSearch/index'
import NewInputBatchSearch from '@/components/NewInputBatchSearch/index.vue'


export default /*#__PURE__*/_defineComponent({
  props: ['form'],
  emits: ['update:form'],
  setup(__props, { emit: emits }) {

const props = __props



const isSku = (val: string) => (/^[A-Za-z0-9]+$/).test(val)

const defaultForm = {
  ingredientsNameJp: '',
  ingredientsSku: '',
  relatedFlag: '',
  startLockQuantity: '',
  endLockQuantity: '',
  startAvailableQuantity: '',
  endAvailableQuantity: '',
  startNoStockQuantity: '',
  endNoStockQuantity: '',
  ingredientsSkuList: []
}

const getForm = (form: any) => setDefaultForm(cloneDeep(toRaw(form)), defaultForm)
const _form = ref(getForm(props.form))

watch(() => props.form, (newValue) => {
  _form.value = getForm(newValue)
  if (newValue.ingredientsSkuList) {
    newSku2Name.value = newValue.ingredientsSkuList
  }
})
const submit = () => {
  emits('update:form', cloneDeep(toRaw(_form.value)))
}
const newSku2Name = ref()
const resetForm = () => {
  clearForm(_form.value)
  newSku2Name.value = undefined

  emits('update:form', cloneDeep(toRaw(_form.value)))
}

const quantityType = ref('availableQuantity')
// const sku2Name = ref('')

// const setSku2Name = () => {
//   _form.value.ingredientsNameJp = ''
//   _form.value.ingredientsSku = ''
//   //   复制粘贴的值也需要去除前后空格
//   const newValue = sku2Name.value?.trim()
//   isSku(newValue)
//     ? _form.value.ingredientsSku = newValue
//     : _form.value.ingredientsNameJp = newValue
// }

const setNewSku2Name = (val: string[]) => {
  const arr = val ?? []
  const arrLength = arr.length
  //   去掉空格之后的值
  const newArr = arr?.map((item) => item?.trim())
  _form.value.ingredientsNameJp = ''
  _form.value.ingredientsSku = ''
  //   若是数组大于0，走批量搜索的入参，模糊搜索
  if (arrLength > 1) {
    _form.value.ingredientsSkuList = newArr
  } else {
    // 否则走单个搜索的入参，精准搜索
    const newValue = newArr?.[0]
    isSku(newValue)
      ? _form.value.ingredientsSku = newValue
      : _form.value.ingredientsNameJp = newValue
    _form.value.ingredientsSkuList = undefined
  }
}

const clearQuantity = () => {
  _form.value.startNoStockQuantity = ''
  _form.value.endNoStockQuantity = ''
  _form.value.startAvailableQuantity = ''
  _form.value.endAvailableQuantity = ''
  _form.value.startLockQuantity = ''
  _form.value.endLockQuantity = ''
}
const startQuantity = computed({
  get: () => {
    if (quantityType.value === 'noStockQuantity') {
      return _form.value.startNoStockQuantity
    }
    if (quantityType.value === 'lockQuantity') {
      return _form.value.startLockQuantity
    }
    if (quantityType.value === 'availableQuantity') {
      return _form.value.startAvailableQuantity
    }
    return ''
  },
  set: (val) => {
    if (quantityType.value === 'noStockQuantity') {
      _form.value.startNoStockQuantity = val
    }
    if (quantityType.value === 'lockQuantity') {
      _form.value.startLockQuantity = val
    }
    if (quantityType.value === 'availableQuantity') {
      _form.value.startAvailableQuantity = val
    }
  }
})
const endQuantity = computed({
  get: () => {
    if (quantityType.value === 'noStockQuantity') {
      return _form.value.endNoStockQuantity
    }
    if (quantityType.value === 'lockQuantity') {
      return _form.value.endLockQuantity
    }
    if (quantityType.value === 'availableQuantity') {
      return _form.value.endAvailableQuantity
    }
    return ''
  },
  set: (val) => {
    if (quantityType.value === 'noStockQuantity') {
      _form.value.endNoStockQuantity = val
    }
    if (quantityType.value === 'lockQuantity') {
      _form.value.endLockQuantity = val
    }
    if (quantityType.value === 'availableQuantity') {
      _form.value.endAvailableQuantity = val
    }
  }
})

const stockNumSnum: any = {
  availableQuantity: t('可用库存'),
  noStockQuantity: t('处理中'),
  lockQuantity: t('锁定')
}

watch(() => quantityType.value, clearQuantity)


return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      inline: true,
      model: _form.value,
      class: "flex"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _unref(t)('物料名/sku'),
          class: "fx-1"
        }, {
          default: _withCtx(() => [
            _createVNode(NewInputBatchSearch, {
              modelValue: newSku2Name.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newSku2Name).value = $event)),
              change: setNewSku2Name,
              placeholder: _unref(t)('双击批量搜索'),
              style: {"width":"100%"}
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('关联状态'),
          class: "fx-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _form.value.relatedFlag,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_form.value.relatedFlag) = $event)),
              style: {"margin-right":"4px","width":"100%"},
              placeholder: _unref(t)('已有关联附加项')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: _unref(t)('已有关联附加项'),
                  value: "1"
                }, null, 8, ["label"]),
                _createVNode(_component_el_option, {
                  label: _unref(t)('未有关联附加项'),
                  value: "0"
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          class: "select-form fx-1",
          label: _unref(t)('可用库存数量筛选')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_select, {
                modelValue: quantityType.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((quantityType).value = $event)),
                style: {"margin-right":"4px","width":"120px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(stockNumSnum, (label, value) => {
                    return _createVNode(_component_el_option, {
                      key: value,
                      label: label,
                      value: value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(startQuantity),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(startQuantity) ? (startQuantity).value = $event : null)),
                    style: {"margin-right":"4px","flex":"1"}
                  }, null, 8, ["modelValue"]),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('至')) + " ", 1),
                  _createVNode(_component_el_input, {
                    modelValue: _unref(endQuantity),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(endQuantity) ? (endQuantity).value = $event : null)),
                    style: {"margin-left":"4px","flex":"1"}
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default"),
      _createVNode(_component_el_button, {
        type: "warning",
        onClick: submit,
        class: "btn"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        onClick: resetForm,
        class: "btn"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})